
export const requiredGet = <K, V>(map: Map<K, V>, key: K) => {
    const result = map.get(key);
    if (!result) {
        throw new Error(`Cannot find key: ${key} in map.`);
    }

    return result;
}